import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import { testimonials } from '@/mocks/testimonials';

const beforeAfterImages = [
  {
    id: 1,
    category: 'Visage',
    title: 'Soin du Visage Hydratant',
    before: 'https://readdy.ai/api/search-image?query=Woman%20with%20dull%20tired%20skin%20before%20facial%20treatment%2C%20uneven%20skin%20tone%2C%20no%20makeup%2C%20natural%20lighting%2C%20clinical%20before%20photo%20style%2C%20neutral%20beige%20background%2C%20professional%20photography&width=400&height=500&seq=kds-ba-01-before&orientation=portrait',
    after: 'https://readdy.ai/api/search-image?query=Beautiful%20African%20woman%20with%20radiant%20glowing%20clear%20skin%20after%20professional%20facial%20treatment%2C%20healthy%20luminous%20complexion%2C%20soft%20natural%20makeup%2C%20confident%20smile%2C%20studio%20lighting%2C%20beauty%20photography%2C%20warm%20tones&width=400&height=500&seq=kds-ba-01-after&orientation=portrait',
    result: 'Après 3 séances',
  },
  {
    id: 2,
    category: 'Regard',
    title: 'Rehaussement de Cils',
    before: 'https://readdy.ai/api/search-image?query=Woman%20natural%20eyes%20without%20makeup%2C%20straight%20eyelashes%2C%20clean%20natural%20look%2C%20neutral%20background%2C%20professional%20beauty%20before%20photo%2C%20soft%20lighting&width=400&height=500&seq=kds-ba-02-before&orientation=portrait',
    after: 'https://readdy.ai/api/search-image?query=Stunning%20woman%20eyes%20with%20beautifully%20curled%20long%20eyelashes%20after%20lash%20lift%20treatment%2C%20defined%20eye%20look%2C%20soft%20glam%20makeup%2C%20close-up%20beauty%20photography%2C%20studio%20lighting%2C%20warm%20tones&width=400&height=500&seq=kds-ba-02-after&orientation=portrait',
    result: 'Résultat immédiat',
  },
  {
    id: 3,
    category: 'Coiffure',
    title: 'Tresses & Locks',
    before: 'https://readdy.ai/api/search-image?query=African%20woman%20natural%20hair%20before%20styling%2C%20simple%20casual%20look%2C%20neutral%20background%2C%20hair%20salon%20before%20photo%20style%2C%20soft%20lighting&width=400&height=500&seq=kds-ba-03-before&orientation=portrait',
    after: 'https://readdy.ai/api/search-image?query=Elegant%20African%20woman%20with%20beautifully%20styled%20braided%20hair%2C%20sophisticated%20look%2C%20confident%20smile%2C%20professional%20beauty%20portrait%2C%20warm%20lighting%2C%20beige%20tones&width=400&height=500&seq=kds-ba-03-after&orientation=portrait',
    result: 'Après 2h',
  },
  {
    id: 4,
    category: 'Corps',
    title: 'Massage Relaxant',
    before: 'https://readdy.ai/api/search-image?query=Woman%20with%20tired%20stressed%20expression%20before%20spa%20treatment%2C%20tense%20posture%2C%20neutral%20background%2C%20soft%20lighting%2C%20professional%20wellness%20photography&width=400&height=500&seq=kds-ba-04-before&orientation=portrait',
    after: 'https://readdy.ai/api/search-image?query=Serene%20relaxed%20woman%20with%20peaceful%20glowing%20expression%20after%20spa%20massage%2C%20calm%20demeanor%2C%20soft%20lighting%2C%20wellness%20beauty%20photography%2C%20warm%20beige%20tones&width=400&height=500&seq=kds-ba-04-after&orientation=portrait',
    result: 'Séance unique',
  },
];

const videoTestimonials = [
  { id: 1, name: 'Marie K.', service: 'Massage Relaxant', avatar: 'MK' },
  { id: 2, name: 'Aïcha B.', service: 'Soin du Visage', avatar: 'AB' },
  { id: 3, name: 'Fatou D.', service: 'Coiffure', avatar: 'FD' },
];

export default function Temoignages() {
  const [activeTab, setActiveTab] = useState<'before-after' | 'clients'>('before-after');
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const elements = entry.target.querySelectorAll('.reveal-item');
            elements.forEach((el, i) => {
              setTimeout(() => { el.classList.add('visible'); }, i * 120);
            });
          }
        });
      },
      { threshold: 0.05 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, [activeTab]);

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }).map((_, i) => (
      <div key={i} className="w-4 h-4 flex items-center justify-center">
        <i className={`ri-star-fill text-sm ${i < rating ? 'text-primary-400' : 'text-background-300'}`} />
      </div>
    ));
  };

  return (
    <Layout>
      {/* Hero */}
      <section className="relative w-full h-[50vh] min-h-[340px] overflow-hidden flex items-center justify-center">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Beautiful%20African%20woman%20with%20radiant%20glowing%20skin%2C%20confident%20smile%2C%20soft%20natural%20makeup%2C%20warm%20studio%20lighting%2C%20luxury%20beauty%20portrait%2C%20beige%20and%20cream%20background%2C%20professional%20photography&width=1600&height=700&seq=kds-temoignages-hero&orientation=landscape"
            alt="Témoignages KD'S BEAUTY"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-foreground-950/50" />
        </div>
        <div className="relative z-10 text-center px-4 w-full">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-50/20 mb-5">
            <span className="text-background-50/90 text-xs tracking-[0.15em] uppercase font-label">Confiance</span>
          </div>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-background-50 font-light mb-4">Avant/Après & Témoignages</h1>
          <p className="text-background-50/70 text-base md:text-lg max-w-2xl mx-auto">Des résultats qui parlent d'eux-mêmes, des clientes qui témoignent</p>
        </div>
      </section>

      {/* Tab Switcher */}
      <section className="w-full py-6 bg-background-50 border-b border-background-200/60 sticky top-16 md:top-20 z-20">
        <div className="w-full px-4 md:px-8">
          <div className="flex items-center justify-center gap-2 max-w-md mx-auto bg-background-100 rounded-full p-1.5 border border-background-200/50">
            <button
              onClick={() => setActiveTab('before-after')}
              className={`flex-1 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap border ${
                activeTab === 'before-after'
                  ? 'bg-primary-500 text-background-50 border-primary-500 shadow-sm'
                  : 'bg-transparent text-foreground-700 border-transparent hover:text-primary-600'
              }`}
            >
              Avant / Après
            </button>
            <button
              onClick={() => setActiveTab('clients')}
              className={`flex-1 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap border ${
                activeTab === 'clients'
                  ? 'bg-primary-500 text-background-50 border-primary-500 shadow-sm'
                  : 'bg-transparent text-foreground-700 border-transparent hover:text-primary-600'
              }`}
            >
              Témoignages Clients
            </button>
          </div>
        </div>
      </section>

      {/* Before/After Gallery */}
      {activeTab === 'before-after' && (
        <section ref={sectionRef} className="w-full py-12 md:py-20 bg-background-50">
          <div className="w-full px-4 md:px-8 lg:px-12 max-w-6xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
              {beforeAfterImages.map((item) => (
                <div
                  key={item.id}
                  className="reveal-item opacity-0 translate-y-6 transition-all duration-700"
                  style={{ transitionTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)' }}
                >
                  <div className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden hover:shadow-lg transition-all duration-500">
                    <div className="px-5 pt-5 pb-2">
                      <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-800 rounded-full mb-2">{item.category}</span>
                      <h3 className="font-heading text-lg text-foreground-800">{item.title}</h3>
                    </div>
                    <div className="grid grid-cols-2 gap-1 mt-2">
                      <div className="relative">
                        <img src={item.before} alt="Avant" className="w-full aspect-[3/4] object-cover" />
                        <span className="absolute top-3 left-3 px-2.5 py-1 text-xs bg-foreground-800/80 text-background-50 rounded-md font-medium">Avant</span>
                      </div>
                      <div className="relative">
                        <img src={item.after} alt="Après" className="w-full aspect-[3/4] object-cover" />
                        <span className="absolute top-3 left-3 px-2.5 py-1 text-xs bg-primary-500 text-background-50 rounded-md font-medium">Après</span>
                      </div>
                    </div>
                    <div className="px-5 py-4 text-center">
                      <span className="text-sm font-semibold text-primary-600">{item.result}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Testimonials */}
      {activeTab === 'clients' && (
        <section ref={sectionRef} className="w-full py-12 md:py-20 bg-background-50">
          <div className="w-full px-4 md:px-8 lg:px-12 max-w-6xl mx-auto">
            {/* Video Testimonials */}
            <div className="mb-14">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-800 text-center mb-8">Témoignages Vidéo</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {videoTestimonials.map((v) => (
                  <div key={v.id} className="reveal-item opacity-0 translate-y-6 transition-all duration-700 bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden hover:border-primary-300/70 hover:-translate-y-2 hover:shadow-lg group cursor-pointer"
                    style={{ transitionTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)' }}>
                    <div className="relative aspect-video bg-background-200 flex items-center justify-center">
                      <div className="w-14 h-14 rounded-full bg-primary-500 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                        <div className="w-6 h-6 flex items-center justify-center"><i className="ri-play-fill text-2xl text-background-50" /></div>
                      </div>
                      <span className="absolute bottom-3 right-3 px-2 py-1 text-xs bg-foreground-800/70 text-background-50 rounded-md">TikTok</span>
                    </div>
                    <div className="p-4">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                          <span className="text-sm font-medium text-primary-700">{v.avatar}</span>
                        </div>
                        <div>
                          <p className="text-sm font-medium text-foreground-800">{v.name}</p>
                          <p className="text-xs text-foreground-500">{v.service}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Written Testimonials */}
            <div>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-800 text-center mb-8">Ce que nos clientes disent</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {testimonials.map((testimonial) => (
                  <div key={testimonial.id} className="reveal-item opacity-0 translate-y-6 transition-all duration-700 bg-background-50 rounded-2xl p-6 md:p-7 border border-background-200/60 hover:border-primary-300/70 hover:shadow-md transition-all duration-500"
                    style={{ transitionTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)' }}>
                    <div className="flex items-center justify-between mb-4">
                      <div className="flex items-center gap-0.5">{renderStars(testimonial.rating)}</div>
                      <span className="text-xs text-foreground-400">{testimonial.date}</span>
                    </div>
                    <div className="w-8 h-8 flex items-center justify-center mb-3"><i className="ri-double-quotes-l text-2xl text-primary-200" /></div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-5">{testimonial.text}</p>
                    <div className="flex items-center gap-3 pt-4 border-t border-background-200/40">
                      <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                        <span className="text-sm font-medium text-primary-700">{testimonial.name.charAt(0)}</span>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-800">{testimonial.name}</p>
                        <p className="text-xs text-primary-500">{testimonial.service}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Bottom CTA */}
      <section className="w-full py-16 bg-secondary-500">
        <div className="w-full px-4 md:px-8 text-center">
          <h2 className="font-heading text-3xl md:text-4xl text-background-50 mb-4">Convaincue ?</h2>
          <p className="text-background-50/80 max-w-xl mx-auto mb-8">Rejoignez nos clientes satisfaites et offrez-vous le soin que vous méritez</p>
          <Link to="/rdv" className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full text-base font-medium bg-green-600 text-white hover:bg-green-700 transition-all duration-300">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line text-lg" />
            </div>
            Prendre rendez-vous
          </Link>
        </div>
      </section>
    </Layout>
  );
}